export default {
  backupsArray: [],
  selectColecciones: [
    {
      text: 'Pedidos',
      value: 'pedidos'
    },
    {
      text: 'Facturas',
      value: 'facturas'
    },
    {
      text: 'Negocios',
      value: 'negocios'
    },
    {
      text: 'Restaurante',
      value: 'restaurante'
    },
  ]
}